export default "__VITE_ASSET__NlqugezP__"